import React from 'react'

export default function loading() {
    return (
        <>
            <div className="typing">
                <div className="typing__dot"></div>
                <div className="typing__dot"></div>
                <div className="typing__dot"></div>
            </div>
        </>
    )
}
